module.exports = __webpack_public_path__ + "img/hamburger.a26aac2f.svg";